/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Flyerentityimagenumber3Inputs */

const en_flyerentityimagenumber3 = /** @type {(inputs: Flyerentityimagenumber3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.number}`)
};

const de_flyerentityimagenumber3 = /** @type {(inputs: Flyerentityimagenumber3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bild ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Image {number}" |
*
* @param {Flyerentityimagenumber3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerentityimagenumber3 = /** @type {((inputs: Flyerentityimagenumber3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerentityimagenumber3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerentityimagenumber3(inputs)
	return de_flyerentityimagenumber3(inputs)
});
export { flyerentityimagenumber3 as "flyerEntityImageNumber" }